import api from "../utils/apiUserCliente";

export const registerCliente = async (data) => {
  const res = await api.post("/api/cliente/acceso/register", {
    nombre: data.nombre,
    apellido: data.apellido,
    codigo_telefono: data.codigo_telefono || null,
    telefono: data.telefono || null,
    correo: data.correo,
    password: data.password,
    confirmPassword: data.confirmPassword,
  });

  const payload = res.data;

  if (payload?.ok && payload?.token) {
    localStorage.setItem("cliente_token", payload.token);
  }

  if (payload?.ok && payload?.cliente) {
    localStorage.setItem("cliente", JSON.stringify(payload.cliente));
  }

  return payload;
};

export const loginCliente = async (correo, password) => {
  const res = await api.post("/api/cliente/acceso/login", {
    correo,
    password,
  });

  const data = res.data;

  if (data?.ok && data?.token) {
    localStorage.setItem("cliente_token", data.token);
  }

  if (data?.ok && data?.cliente) {
    localStorage.setItem("cliente", JSON.stringify(data.cliente));
  }

  return data;
};

// Restablecimiento de contraseña del cliente (endpoints públicos).
export const solicitarResetCliente = async (correo) => {
  const res = await api.post("/api/cliente/acceso/password/solicitar-reset", { correo });
  return res.data;
};

export const validarResetCliente = async (token) => {
  const res = await api.get("/api/cliente/acceso/password/validar-reset", { params: { token } });
  return res.data;
};

export const restablecerPasswordCliente = async ({ token, password, confirmPassword }) => {
  const res = await api.post("/api/cliente/acceso/password/restablecer", {
    token,
    password,
    confirmPassword,
  });
  return res.data;
};

export const logoutCliente = () => {
  localStorage.removeItem("cliente_token");
  localStorage.removeItem("cliente");
};


export const getClienteLocal = () => {
  const cliente = localStorage.getItem("cliente");
  return cliente ? JSON.parse(cliente) : null;
};


export const isClienteAuthenticated = () => {
  return Boolean(localStorage.getItem("cliente_token"));
};

export const validateClienteSession = async () => {
  try {
    const res = await api.get("/api/cliente/acceso/authorize");
    return {
      ok: true,
      session: res.data,
    };
  } catch (err) {
    const status = err?.response?.status;

    if (status === 401 || status === 403) {
      logoutCliente();
      return { ok: false, reason: "invalid_or_expired" };
    }

    return { ok: true, warning: "network_or_server" };
  }
};